import HttpJson from './json'
import HttpFormData from './formData'

const httpJson = HttpJson.create()
const httpFormData = HttpFormData.create()

const cfClient = {
  json: httpJson,
  formData: httpFormData,
}

export default cfClient
